import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { emailSac } from '@/utils/consts/sac.consts';
import { Link } from '@/components/ui/link/link.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaqEmailSacButton = () => {
  const { buttonSmFit } = styleFaq();

  return (
    <Button
      asChild
      className={buttonSmFit()}
      startIcon={faEnvelope}
      variant="secondary"
    >
      <Link
        prefetch={false}
        href={emailSac}
        target="_blank"
        data-testid={DataTestIdEnum.FAQ_EMAIL_SAC_BUTTON}
        data-analytics-event={AnalyticsEnum.CLICK_FAQ_EMAIL_SAC_BUTTON}
      >
        E-mail do SAC
      </Link>
    </Button>
  );
};
